import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/products";

export default function FloatingActions() {
  const waNumber = BRAND.phones[0];
  const waMsg = encodeURIComponent(
    "Hi Beemamen, I would like to know more about an insurance plan."
  );
  return (
    <div className="fixed bottom-5 right-4 md:right-6 z-40 flex flex-col gap-3">
      <a
        data-testid="floating-whatsapp"
        href={`https://wa.me/91${waNumber}?text=${waMsg}`}
        target="_blank"
        rel="noreferrer"
        className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-xl flex items-center justify-center transition-transform hover:scale-105"
        aria-label="WhatsApp"
      >
        <span className="pulse-ring" />
        <MessageCircle className="w-6 h-6 relative z-10" />
      </a>
      <a
        data-testid="floating-call"
        href={`tel:+91${BRAND.phones[0]}`}
        className="w-14 h-14 rounded-full bg-[#1e3a8a] hover:bg-[#172554] text-white shadow-xl flex items-center justify-center transition-transform hover:scale-105"
        aria-label="Call"
      >
        <Phone className="w-5 h-5" />
      </a>
    </div>
  );
}
